import './rater.coverage.list.scss';

import { Fragment, memo } from 'react';

import { COVERAGE_TYPE_LABELS } from '@converge/data';
import { RaterCoverageListDetail } from './list-detail/rater.coverage.list.detail';
import { RaterTableTitleCell } from '../rater.content.table';
import { TableRow } from '@mui/material';
import { capitalizeWordsExceptPreposition } from '@converge/utils';
import { useRaterStateContextSelector } from '../data';

const getTypeLabel = (label: string) => {
  return COVERAGE_TYPE_LABELS[label] ?? label;
};

export const RaterCoverageList = memo(
  () => {
    const { coverages, endorsements, columnCount, isEditable, inForcePolicy } =
      useRaterStateContextSelector(
        ({
          quote: { coverages, endorsements, inForcePolicy },
          columnCount,
          isEditable,
        }) => {
          return {
            coverages,
            endorsements,
            columnCount,
            isEditable,
            inForcePolicy,
          };
        }
      );

    const types: Record<string, boolean> = {};

    return (
      <Fragment>
        {coverages.map((coverage, index) => {
          const row = (
            <RaterCoverageListDetail
              key={coverage.name}
              isEditable={isEditable && !inForcePolicy}
              coverage={coverage}
              index={index}
              isLastRow={index === endorsements.length + coverages.length - 1}
            />
          );

          if (coverage.type && !types[coverage.type]) {
            types[coverage.type] = true;
            return (
              <Fragment key={index}>
                <TableRow className="rater-list-table-row">
                  <RaterTableTitleCell columnCount={columnCount}>
                    {capitalizeWordsExceptPreposition(
                      getTypeLabel(coverage.type)
                    )}
                  </RaterTableTitleCell>
                </TableRow>
                {row}
              </Fragment>
            );
          }
          return row;
        })}
      </Fragment>
    );
  },
  () => {
    return true;
  }
);
